import { Typography } from '@sede-enterprise/shell-ds-react-framework';
import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import { SPACING_2 } from 'constants/theme-constants';
import styled from 'styled-components';

export const HeaderTextWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    
  `}
`;
export const IntroHeaderTextWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    margin-left: ${cxTheme.spacing[SPACING_2]};
    align-items: center;
    z-index: 2;
  `}
`;

export const LogoAndHeaderTextWrapper = styled.div<{ isMobile: boolean }>`
  ${({ theme, isMobile }) => `
    display: flex;
    margin: ${isMobile ? `16px 0 0 16px` : `48px 0 0 38px`};
  `}
`;
LogoAndHeaderTextWrapper.displayName = 'LogoAndHeaderTextWrapper';

export const IntroHeaderSubText = styled.span<{ isMobile: boolean }>`
  ${({ theme, isMobile }) => {
    return `
    ${
      isMobile ? Typography.label.medium.bold : Typography.label.extraLarge.demi
    };
    color: ${theme.text.onSecondary.strong};
  `;
  }}
`;

export const IntroHeaderText = styled.span<{ isMobile: boolean }>`
  ${({ theme, isMobile }) => `
    ${isMobile ? Typography.heading[4].bold : Typography.heading[3].demi};
    color: ${theme.text.onSecondary.strong};
  `}
`;

export const IntroDivider = styled.div`
  ${({ theme }) => `
    background: rgba(255, 255, 255, 0.99);
    height: 33px;
    width: 1px;
    margin-right: ${cxTheme.spacing[SPACING_2]};
  `}
`;
